import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CxImageModule } from '@bbraun/cortex/image';
import { CxMessageModule } from '@bbraun/cortex/message';
import { TranslocoDirective } from '@jsverse/transloco';

import { NoAccessReasons } from '../../definitions/enums/user/no-access-reasons.enum';

@Component({
  selector: 'app-access-error',
  imports: [
    CxMessageModule,
    TranslocoDirective,
    CxImageModule
  ],
  templateUrl: './access-error.component.html',
  styleUrls: [ './access-error.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessErrorComponent {
  protected readonly reason = NoAccessReasons.LOGIN_ERROR;
}
